module.exports = __webpack_public_path__ + "assets/img/2121591934007_.pic_hd.2079e3b4.jpg";